export const getUnlockedCategoryPath = (categoryId: string | number) =>
  `/open-content/${categoryId}`;

export const getUnlockedContentPath = (categoryId: string | number, contentId: string | number) =>
  `/open-content/${categoryId}/${contentId}`;

export const getLockedContentPath = (contentId: string | number) => `/locked-content/${contentId}`;
